import { useState, useEffect } from 'react';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import { LevelOperatorType } from '../common/constants/LevelOperatorType';
import store, { levelActions } from '@apply/adminStore';
import LevelModal from '../modals/LevelModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { PermissionType } from '@apply/constants';
import { hasPermission } from '@apply/ui';

const LevelsTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);

    const [dataStore, set_dataStore] = useState(gridStore?.store);
    const { dispatch } = store;

    const dataFunction = (criteria) => experienceApi.getLevels(criteria);

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.adminUser);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onCellDblClick = (e) => {
        dispatch(
            levelActions.setLevelModal({
                levelModal: { isOpen: true, levelId: e.data.id },
            })
        );
    };

    const onActionCellRender = (e) => {
        return (
            <button
                id='editLevel'
                className='gridButton'
                title='Edit Level'
                onClick={(event) => onCellDblClick(e)}
            >
                <FontAwesomeIcon icon={hasPermission(PermissionType.ExperienceConfigurator) ? faPencil : faEye} />
            </button>
        );
    };

    const onBfiRepaymentsCellRender = (e) => {
        return getOperatorValueString(e.data.bfiRepaymentsOperatorId, Number(e.value).toFixed());
    };

    const onSoldHomesCellRender = (e) => {
        return getOperatorValueString(e.data.soldHomesOperatorId, Number(e.value).toFixed());
    };

    const getOperatorValueString = (operatorId, value) => {
        switch (operatorId) {
            case LevelOperatorType.EqualTo: {
                return value;
            }
            case LevelOperatorType.GreaterThan: {
                return '> ' + value;
            }
            case LevelOperatorType.GreaterThanOrEqualTo: {
                return value + ' +';
            }
            case LevelOperatorType.LessThan: {
                return '< ' + value;
            }
            case LevelOperatorType.LessThanOrEqualTo: {
                return '<= ' + value;
            }
            default: {
                return value;
            }
        }
    };

    return (
        <>
            <BfiDataGrid
                gridType={GridSettingType.ExperienceLevels}
                dataStore={dataStore}
                applicationInsights={applicationInsights}
                width={'100%'}
                onCellDblClick={onCellDblClick}
            >
                <Column
                    dataField='levelName'
                    name='levelName'
                    caption='Level Name'
                    dataType='string'
                />
                <Column
                    dataField='soldHomes'
                    name='soldHomes'
                    cellRender={onSoldHomesCellRender}
                    caption='Sold Homes'
                />
                <Column
                    dataField='bfiRepayments'
                    name='bfiRepayments'
                    cellRender={onBfiRepaymentsCellRender}
                    caption='BFI Repayments'
                />
                <Column
                    dataField='maxLTC'
                    name='maxLTC'
                    caption='Maximum LTC'
                    dataType='number'
                    format={{ type: 'percent', precision: 0 }}
                />
                <Column
                    dataField='maxLTV'
                    name='maxLTV'
                    caption='Maximum LTV'
                    dataType='number'
                    format={{ type: 'percent', precision: 0 }}
                />
                <Column
                    dataField='notes'
                    name='notes'
                    caption='Notes'
                    dataType='string'
                />
                <Column
                    alignment='center'
                    cellRender={onActionCellRender}
                    width={50}
                    allowReordering={false}
                    allowSorting={false}
                    allowResizing={false}
                />
            </BfiDataGrid>
            <LevelModal />
        </>
    );
};

export default LevelsTable;
